<div *ngIf="items$ | async as items" class="important-links pr-xlarge-t mr-large-b">
  <h2>{{ (content$ | async)?.teaserTitle }}</h2>

  <div class="important-links-area flex flex--wrap rounded border-top border-left">
    <a
      *ngFor="let item of items; last as isLast"
      [finLink]="item?.target?.url"
      [external]="item?.target?.external"
      class="important-link flex flex--middle nordic-blue-900-text text-icon-primary bold-type font-body-1 ps-medium no-underline border-bottom border-right underline-hover font-body-medium-bold"
      [class.rounded-bottom-right]="isLast"
      data-testid="cms-important-link"
    >
      <span class="title">
        {{ item?.teaserTitle }}
      </span>
      <span class="cta">
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
      </span>
    </a>
  </div>
</div>
